(ns app.front.view.group.admin.locales
  (:require [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.select :as ui-select]
            [app.front.util :refer [for-frag]]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.subs :as gas]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.i18n :as i18n]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::toggle-language
  (fn [{:keys [db]} [_ group-id language enable?]]
    {:comm/command {:command    :group/toggle-language
                    :data       (util/mmap language group-id enable?)
                    :on-success [::toggle-language.success]
                    :notify     {:success :group-locales/toggle-success}}
     :db           (assoc db ::loading? true)}))

(rf/reg-event-fx ::toggle-language.success
  (fn [{:keys [db]} [_ status resp]]
    {:db       (assoc db ::loading? false)
     :dispatch [::entities/apply-changes status resp]}))

(rf/reg-event-fx ::set-default-language
  (fn [{:keys [db]} [_ group-id language]]
    {:comm/command {:command          :group/set-default-language
                    :data             (cond-> {:group-id group-id}
                                        language (assoc :language language))
                    :on-success       [::entities/apply-changes]
                    :finally-dispatch [::set-default-language.finally]
                    :notify           {:success :group-locales/default-language-success}}
     :db           (assoc db ::loading? true)}))

(rf/reg-event-db ::set-default-language.finally
  (fn [db _]
    (assoc db ::loading? false)))

(rf/reg-sub ::lang-enabled
  :<- [::gas/allowed-locales]
  (fn [languages [_ lang]]
    (->> languages lang boolean)))

(rf/reg-sub ::loading?
  (fn [db _]
    (::loading? db false)))

(rf/reg-sub ::disabled?
  :<- [::loading?]
  :<- [::gas/allowed-locales]
  (fn [[loading? enabled-locales] [_ lang]]
    (or loading?
        ;; at least one language must remain enabled
        (= enabled-locales #{lang}))))

(rf/reg-sub ::default-language
  :<- [::gas/group]
  :-> :group/default-language)

(defn- default-language-dropdown [tr group-id]
  (let [all-locales      (<sub [::i18n/locales])
        enabled-locales  (<sub [::gas/allowed-locales])
        default-language (<sub [::default-language])
        loading?         (<sub [::loading?])
        values           (filterv #(contains? enabled-locales %) (keys all-locales))]
    [:div.mt-8
     [:div.max-w-sm
      [ui-select/select {:id           "default-language-override"
                         :label-text   (tr [:group-locales/override-default-language])
                         :values       values
                         :value        default-language
                         :val->str     #(:name (get all-locales %))
                         :select-text  (tr [:group-locales/none])
                         :allow-empty? true
                         :disabled     loading?
                         :on-change    #(>evt [::set-default-language group-id %])}]]
     [ui/help (tr [:group-locales/override-default-language-help])]]))

(defn view [match]
  (let [tr       (<sub [:tr])
        group-id (<sub [::gas/group-id])
        group    (<sub [::gas/group])]
    [acommon/admin-page
     (util/mmap {:title (tr [:view/group.admin.locales])} match)
     [acommon/section {:title (tr [:group-locales/select-locales])}
      [ui/help (tr [:group-locales/select-locales-help])]
      [:div.flex
       [:div
        (for-frag [[lang {:keys [name]}] (<sub [::i18n/locales])
                   :let [enabled? (<sub [::lang-enabled lang])]]
          [:div.flex.items-end
           [:div.flex-none.w-28
            (cc/toggle {:id         (str "toggle-" lang)
                        :disabled   (<sub [::disabled? lang])
                        :toggled    enabled?
                        :aria-label name
                        :on-toggle  #(>evt [::toggle-language group-id lang (not enabled?)])})]
           [:div.flex-1>p.pb-1.font-bold name]])]
       (when (<sub [::loading?])
         (cc/loading-spinner {:with-overlay false}))]
      (when (and (not-empty (:group/languages group))
                 (#{:group.type/domain :group.type/superdomain} (:group/type group)))
        [default-language-dropdown tr group-id])]]))

(def route
  {:name :view/group.admin.locales
   :view view})
